import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './StoryCard-tw-styles';
import Typography from '../../Generic/Typography';
import ListingCards from '../Product';
import { getImageSet, getImage } from '../../../utils/uiHelper';
import i18nMessages from '../../../constants/messages/pt-BR';
import DOMPurify from 'isomorphic-dompurify';

class StoryCard extends Component {
  state = {};

  render() {
    const { data, locale } = this.props;
    let contentType = data.styles && data.styles.trim();
    if (styles[contentType] === undefined) {
      contentType = i18nMessages.pantenestorycard;
    }
    return (
      <div className={classNames(styles[contentType].mainWrapper)}>
        <div className={classNames(styles[contentType].imageWrapper)}>
          {data.primaryImageCollection &&
            data.primaryImageCollection.items.map(content => {
              if (content) {
                switch (content.__typename) {
                  case i18nMessages.ImageSet:
                    return getImageSet(content);
                  case i18nMessages.Image:
                    return getImage(content);
                  default:
                    return null;
                }
              }
            })}
          <Typography
            key={data.sys.id}
            className={classNames(styles[contentType].headingStyle)}
            component="div"
            dangerouslySetInnerHTML={
              data.title && {
                __html:DOMPurify.sanitize( data.title),
              }
            }
          />
        </div>

        <div className={classNames(styles[contentType].textContent)}>
          <Typography
            key={data.sys.id}
            className={classNames(styles[contentType].subText)}
            component="div"
            dangerouslySetInnerHTML={
              data.text && {
                __html:DOMPurify.sanitize( data.text),
              }
            }
          />
          <Typography
            key={data.sys.id}
            className={classNames(styles[contentType].subTitle)}
            component="div"
            dangerouslySetInnerHTML={
              data.subTitle && {
                __html:DOMPurify.sanitize( data.subTitle),
              }
            }
          />
          {data.secondaryImageCollection &&
            data.secondaryImageCollection.items.map(content => {
              if (content) {
                switch (content.__typename) {
                  case i18nMessages.ImageSet:
                    return getImageSet(content);
                  case i18nMessages.Image:
                    return getImage(content);
                }
              }
            })}
          <div className={classNames(styles[contentType].releatedCard)}>
            {
              data.relatedProductCollection &&
              data.relatedProductCollection.items.map((content,index)=>{
                content.styles='storyReleatedCard'
                return (
                  <a className={classNames(styles[contentType].releatedCardLink)} href={`${'/pt-br/produtos/'+ content.parentPage.slug.toLowerCase() + '/' + content.slug}`}>
                    <ListingCards
                      locale={locale}
                      data={content}
                      key={index}
                    />
                  </a>
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

StoryCard.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]),
  locale: PropTypes.string
};

StoryCard.defaultProps = {
  data: null,
  locale: "pt-br"
};
export default StoryCard;
